export default __webpack_public_path__ + "static/media/star-purple.c944c517.svg";